<template>
  <div :class="t.wrapperLoose">
    <label :class="t.label">
      {{ question.prompt }}
      <span v-if="!question.required" class="text-gray-400 font-normal">(optional)</span>
    </label>
    <p
      v-if="question.subtext"
      :class="t.subtext"
      v-html="question.subtext"
    ></p>

    <!-- Options as tappable buttons -->
    <div :class="t.wrapperLoose">
      <button
        v-for="option in question.answers"
        :key="option"
        @click="selectOption(option)"
        type="button"
        :class="t.optionButton"
        :style="buttonStyle(option)"
        @mouseenter="hoveredOption = option"
        @mouseleave="hoveredOption = null"
      >
        <!-- Radio circle indicator -->
        <span
          :class="[t.optionIndicator, 'rounded-full border-2']"
          :style="radioStyle(option)"
        >
          <span
            v-if="answer === option"
            :class="[t.optionIndicatorInner, 'rounded-full']"
            style="background-color: var(--team-text)"
          ></span>
        </span>
        <span class="font-medium">{{ option }}</span>
      </button>
    </div>

    <!-- Error Message -->
    <p v-if="error" :class="t.error">
      Please select an option.
    </p>
  </div>
</template>

<script>
import { tokensFor } from './size_tokens';

export default {
  name: 'QuestionSingleSelect',
  props: {
    question: {
      type: Object,
      required: true,
    },
    existingAnswer: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: 'kiosk',
      validator: (v) => ['kiosk', 'form'].includes(v),
    },
  },
  data() {
    return {
      answer: '',
      originalAnswer: '',
      error: false,
      hoveredOption: null,
    };
  },
  computed: {
    t() {
      return tokensFor(this.size);
    },
    dirty() {
      return this.answer !== this.originalAnswer;
    },
    valid() {
      if (this.question.required) {
        return this.answer.length > 0;
      }
      return true;
    },
  },
  watch: {
    answer() {
      this.emit();
      if (this.valid) {
        this.error = false;
      }
    },
  },
  created() {
    if (this.existingAnswer && this.existingAnswer.answer) {
      this.answer = this.existingAnswer.answer;
      this.originalAnswer = this.existingAnswer.answer;
    }
    this.$notificationManager?.on('show-reg-errors', this.validate);
  },
  destroyed() {
    this.$notificationManager?.off('show-reg-errors', this.validate);
  },
  methods: {
    buttonStyle(option) {
      const isSelected = this.answer === option;
      const isHovered = this.hoveredOption === option;

      if (isSelected) {
        return {
          backgroundColor: 'var(--team-primary)',
          borderColor: 'var(--team-primary)',
          color: 'var(--team-text)',
        };
      }
      if (isHovered) {
        return {
          borderColor: 'var(--team-primary)',
          backgroundColor: '#F9FAFB',
          color: '#374151',
        };
      }
      return {
        borderColor: '#D1D5DB',
        backgroundColor: 'white',
        color: '#374151',
      };
    },
    radioStyle(option) {
      const isSelected = this.answer === option;
      if (isSelected) {
        return {
          borderColor: 'var(--team-text)',
          backgroundColor: 'var(--team-primary)',
        };
      }
      return {
        borderColor: '#D1D5DB',
        backgroundColor: 'white',
      };
    },
    selectOption(option) {
      this.answer = option;
    },
    emit() {
      this.$emit('answer-changed', this.question, this.answer, this.dirty, this.valid);
    },
    validate() {
      this.error = !this.valid;
    },
  },
};
</script>
